module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av200-eec0d5c29b7c757be7d2577a2765b6db.jpg";